var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { combineLatest } from "rxjs";
import { State } from "./State";
var CombinerState = /** @class */ (function (_super) {
    __extends(CombinerState, _super);
    function CombinerState(states) {
        // input
        var input = combineLatest(states.map(function (o) { return o.changes$(); }), function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return args;
        });
        // isNonValue
        var isNonValue = function (x) {
            if (x === undefined) {
                return true;
            }
            if (x.length === 0) {
                return true;
            }
            for (var _i = 0, x_1 = x; _i < x_1.length; _i++) {
                var v = x_1[_i];
                if (v === undefined) {
                    return true;
                }
            }
            return false;
        };
        var afterConnect = function () {
        };
        var afterDisConnect = function () {
        };
        return _super.call(this, input, isNonValue, afterConnect, afterDisConnect) || this;
    }
    return CombinerState;
}(State));
export { CombinerState };
export function combine() {
    var states = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        states[_i] = arguments[_i];
    }
    return new CombinerState(states);
}
